<script lang="ts" setup>
import CoreButton from "@/components/common/CoreButton/CoreButton.vue";
import MainLayout from "@/components/layout/MainLayout.vue";
import MainNav from "@/components/layout/navigation/MainNav.vue";
import LogosJoined from "@/pages/upgrade/components/LogosJoined.vue";
import SignInAppPreview from "./SignInAppPreview.vue";
import SupgradeFaq from "@/pages/upgrade/components/SupgradeFaq.vue";
import { ElDivider } from "element-plus";
import { useSupgrade } from "@/composables/supgrade/supgrade";
import { config } from "@/config/envConfig";

const { isUpgrader } = useSupgrade();

const navigateToSignInApp = () => {
  window.location.href = `${config.SIA_URL}/login`;
};

const navigateToSignInAppReset = () => {
  window.location.href = `${config.SIA_URL}/upgrade/reset`;
};
</script>
<template>
  <div class="container">
    <MainNav />
    <MainLayout class="main">
      <div class="content">
        <LogosJoined />
        <h1>{{ $t("supgrade.complete.heading") }}</h1>
        <p>
          {{ $t("supgrade.complete.body1") }} <br />
          {{ $t("supgrade.complete.body2") }}
        </p>
        <template v-if="isUpgrader">
          <CoreButton
            type="primary"
            @click="navigateToSignInApp"
          >
            {{ $t("supgrade.complete.button") }}
          </CoreButton>
        </template>
        <template v-else>
          <p>
            {{ $t("supgrade.complete.body3") }}
          </p>
          <div class="btn-group">
            <CoreButton
              type="primary"
              plain
              @click="navigateToSignInAppReset"
            >
              {{ $t("forms.login.setPassword.button") }}
            </CoreButton>
            <CoreButton
              type="primary"
              @click="navigateToSignInApp"
            >
              {{ $t("supgrade.complete.button") }}
            </CoreButton>
          </div>
        </template>
      </div>
      <el-divider class="divider" />
      <div class="preview-container">
        <SignInAppPreview />
        <SupgradeFaq />
      </div>
    </MainLayout>
  </div>
</template>
<style lang="scss" scoped>
.btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  &:deep(.so-button) {
    min-width: 11rem;
    margin: 0;
    flex: 1;
  }
}
.divider {
  margin: 4rem 0;
}
.preview-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 3rem;
  & div {
    flex: 1;
    min-width: 360px;
  }
}
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
}
.container {
  flex: 1;
}
.main {
  padding-top: 0;
}
</style>
